import styled from "@emotion/styled";
import { ALWAYS_ON_TOP, LAYER_ONE, LAYER_TWO } from "constants/z-index";
const IMAGE_DEFAULT_MAX_WIDTH = "900px";
const DEFAULT_ASSETS_AND_TAGS_EXTRA_SPACE = "10vw";
const getBreathAnimation = (isCentralized, flipUseCasesAndAssets)=>{
    const transformStyle = isCentralized ? `translateX(${flipUseCasesAndAssets ? "50%" : "-50%"})` : "";
    return `
    @keyframes breathe {
    0% {
      transform: ${transformStyle} scale(1);
    }
    50% {
      transform: ${transformStyle} scale(1.05);
    }
    100% {
      transform: ${transformStyle} scale(1);
    }
  }
  `;
};
export const StyledTagsAndAssetsComponent = styled.div`
	position: relative;
	width: fit-content;

	&.centered {
		.use-cases-container {
			${({ flipUseCasesAndAssets })=>flipUseCasesAndAssets ? "right: 50%;" : "left: 50%;"}
			${({ flipUseCasesAndAssets })=>flipUseCasesAndAssets ? "transform: translateX(50%);" : "transform: translateX(-50%);"}
		}
	}

	&.movement-animation {
		.use-cases-container {
			animation: moveToPositionFromCenter 1s forwards ease;
		}
	}

	&:not(.centered) {
		.use-cases-container {
			${({ flipUseCasesAndAssets })=>flipUseCasesAndAssets ? "right: 0;" : "left: 0;"}
		}

		.assets-container {
			transition: margin 1s ease;
			transition-delay: ${({ startAtCenterAnimationDelay })=>parseFloat(startAtCenterAnimationDelay) || 0}s;
			${({ flipUseCasesAndAssets, assetsAndTagsExtraSpace })=>flipUseCasesAndAssets ? `margin-right: ${assetsAndTagsExtraSpace || DEFAULT_ASSETS_AND_TAGS_EXTRA_SPACE};` : `margin-left: ${assetsAndTagsExtraSpace || DEFAULT_ASSETS_AND_TAGS_EXTRA_SPACE};`}
		}
	}

	.use-cases-container {
		z-index: ${LAYER_TWO};
		position: absolute;
		top: ${({ useCasesTopMargin })=>useCasesTopMargin || "calc(132 * (100vw / 1920))"};

		&.breathe {
			animation: breathe 0.3s linear;
		}
	}

	img {
		width: 100%;
		object-fit: contain;
		max-width: ${({ imageMaxWidth })=>imageMaxWidth || IMAGE_DEFAULT_MAX_WIDTH};
	}

	.default-asset {
		opacity: 0;
		transition: opacity 0.3s ease-in-out;

		.asset-inner img {
			${({ blurDefaultImage })=>blurDefaultImage ? "filter: blur(5px);" : ""}
			${({ blurDefaultImage })=>blurDefaultImage ? "opacity: 0.5;" : ""}
		}

		&.active {
			display: block;
			z-index: ${ALWAYS_ON_TOP};
			opacity: 1;
		}
	}

	.assets-container {
		z-index: ${LAYER_ONE};
		position: relative;
		width: fit-content;
		min-width: ${({ imageMaxWidth })=>imageMaxWidth};

		.picture-wrapper {
			width: fit-content;
			position: absolute;
			opacity: 0;
			top: 0;
			left: 0;
			transition: opacity 0.3s ease-in-out;

			&.selected {
				opacity: 1;
			}
		}
	}

	@keyframes moveToPositionFromCenter {
		0% {
			${({ flipUseCasesAndAssets })=>flipUseCasesAndAssets ? "right: 50%;" : "left: 50%;"}
			${({ flipUseCasesAndAssets })=>flipUseCasesAndAssets ? "transform: translateX(50%);" : "transform: translateX(-50%);"}
		}
		100% {
			${({ flipUseCasesAndAssets })=>flipUseCasesAndAssets ? "right: 0;" : "left: 0;"}
			transform: translateX(0);
		}
	}

	${({ isCentralized, flipUseCasesAndAssets })=>getBreathAnimation(isCentralized, flipUseCasesAndAssets)}
`;
